import { render, staticRenderFns } from "./EntregaForm.vue?vue&type=template&id=60cb25be"
import script from "./EntregaForm.vue?vue&type=script&lang=js"
export * from "./EntregaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports